import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';

export const FETCH_AI_DRAFT_CONTENT =
	'state.actions.fetch-ai-draft-content.FETCH_AI_DRAFT_CONTENT' as const;

export type FetchAIDraftContentPayload = {
	projectId: number;
	activationId: string;
	topicId: string;
	analyticsEvent: UIAnalyticsEvent;
};
export type FetchAIDraftContentAction = {
	type: typeof FETCH_AI_DRAFT_CONTENT;
	payload: FetchAIDraftContentPayload;
};

export const fetchAIDraftContent = (
	payload: FetchAIDraftContentPayload,
): FetchAIDraftContentAction => ({
	type: FETCH_AI_DRAFT_CONTENT,
	payload,
});
